import { ArrowRightIcon, Button, Flex, Text } from "@fluentui/react-northstar";
import React, { useState } from "react";
import { useMutation } from "react-query";

import styled from "styled-components";
import { _api_approve_or_edit_slot } from "../../api";
import moment from "moment";
import StripedTypeLeaveWeek from "../StripedTypeLeaveWeek";

export default function EditedSlots({
    setConfigToast,
    slot_data,
    refetchSlotData,
}) {
    const [hiddenButtons, setHiddenButtons] = useState([]);
    const [loadingButtons, setLoadingButtons] = useState([]);
    const { mutate, isLoading: isLoadingEditShift } = useMutation((data) => {
        return _api_approve_or_edit_slot(data);
    });
    const Approve_or_refuse_edit_slot = (data) => {
        const buttonKey = `${data?.shift_id}-${data?.step}`;
        setLoadingButtons((prev) => ({ ...prev, [buttonKey]: true }));
        // you need to remove the comment of this  mutate
        mutate(
            {
                user_id: data?.user_id,
                shift_id: data?.shift_id,
                step: data?.step,
            },
            {
                onSuccess: (response) => {
                    if (response?.success) {
                        setConfigToast({
                            visible: true,
                            content:
                                data?.step === "reject"
                                    ? `Créneau refusé`
                                    : `Créneau approuvé`,
                            level: "success",
                        });
                        // Ajouter l'ID du créneau aux boutons cachés
                        setHiddenButtons((prev) => [...prev, data?.shift_id]);

                        // Retirer le bouton spécifique de l'état de chargement
                        setLoadingButtons((prev) => {
                            const updatedLoading = { ...prev };
                            delete updatedLoading[buttonKey];
                            return updatedLoading;
                        });
                        refetchSlotData();
                        return;
                    }
                    // si la réponse du back est un erreur
                    else {
                        setConfigToast({
                            visible: true,
                            content: response?.error,
                            level: "danger",
                        });
                        setLoadingButtons((prev) => {
                            const updatedLoading = { ...prev };
                            delete updatedLoading[buttonKey];
                            return updatedLoading;
                        });
                    }
                },
            }
        );
    };

    const _formated_time = (time) => {
        return moment(time, "HH:mm:ss").format("HH:mm");
    };

    if (slot_data?.type?.value === 2) {
        return (
            <Flex column>
                <Text content={slot_data?.type?.leave_name} />
                <StripedTypeLeaveWeek
                    background_color={slot_data.type?.leave_color + "50"}
                    leave_name={slot_data.type?.leave_name}
                    striped_color={slot_data.type?.leave_color}
                    pending={slot_data?.type?.is_pending_leave}
                    // hours={8}
                />
            </Flex>
        );
    }

    if (slot_data?.shifts?.length === 0) {
        return (
            <Flex
                styles={{ outline: "2px dashed grey", padding: "16px" }}
                hAlign="center"
                fill
                column
            >
                <Text content="La liste des créneaux est vide" />
            </Flex>
        );
    }

    return slot_data?.shifts?.map((shift) => {
        return (
            <>
                {shift?.id === -1 && (
                    <BreakFlex
                        BreakRespected={shift?.pause_respected}
                        fill
                        hAlign="center"
                    >
                        {/* <BreakText content="Pause : 00h30" /> */}
                        <BreakText content={`Pause : ${shift?.duration}`} />
                    </BreakFlex>
                )}
                {shift?.manager_approval_required && shift?.id !== -1 && (
                    <Flex gap="gap.small" fill column>
                        <Flex fill gap="gap.medium" vAlign="center">
                            <OldSlot fill column>
                                <Flex gap="gap.small" vAlign="center">
                                    <OldSlotText
                                        content={
                                            _formated_time(
                                                shift?.old_start_time
                                            ) ?? "--:--"
                                        }
                                    />
                                    <ArrowRightIcon />
                                    <OldSlotText
                                        content={
                                            _formated_time(
                                                shift?.old_end_time
                                            ) ?? "--:--"
                                        }
                                    />
                                </Flex>
                                <DurationText
                                    content={`Durée : ${shift?.old_duration_str}`}
                                />
                            </OldSlot>
                            <ArrowRightIcon />
                            <NewSlot fill column>
                                <Flex gap="gap.small" vAlign="center">
                                    <NewSlotText
                                        content={_formated_time(
                                            shift?.start_time
                                        )}
                                    />
                                    <ArrowRightIcon />
                                    <NewSlotText
                                        content={_formated_time(
                                            shift?.end_time
                                        )}
                                    />
                                </Flex>
                                <DurationText
                                    content={`Durée : ${shift?.duration_str}`}
                                />
                            </NewSlot>
                        </Flex>
                    </Flex>
                )}
                {/* after approve or refuse the edited slot  */}

                {/* buttons  */}
                {shift?.manager_approval_required && (
                    <Flex space="between" gap="gap.large" fill>
                        {/* button refusé  */}
                        {!hiddenButtons?.includes(shift?.id) && (
                            <Button
                                loading={
                                    !!loadingButtons[`${shift?.id}-reject`]
                                }
                                fluid
                                styles={{ width: "182px" }}
                                onClick={() =>
                                    Approve_or_refuse_edit_slot({
                                        shift_id: shift?.id,
                                        step: "reject",
                                        user_id: slot_data?.user?.id,
                                    })
                                }
                                flat
                                content="Refuser"
                            />
                        )}

                        {/* button approve */}

                        {!hiddenButtons?.includes(shift?.id) && (
                            <Button
                                loading={
                                    !!loadingButtons[`${shift?.id}-approve`]
                                }
                                styles={{ width: "182px" }}
                                fluid
                                onClick={() =>
                                    Approve_or_refuse_edit_slot({
                                        shift_id: shift?.id,
                                        step: "approve",
                                        user_id: slot_data?.user?.id,
                                    })
                                }
                                flat
                                content={<ButtonText content="Valider" />}
                                primary
                            />
                        )}
                    </Flex>
                )}
                {shift?.type?.leave_name && (
                    <Flex fill column>
                        {/* <Text content={shift?.type?.leave_name} /> */}
                        <StripedTypeLeaveWeek
                            background_color={shift.type?.leave_color + "50"}
                            leave_name={shift?.type?.leave_name}
                            striped_color={shift.type?.leave_color}
                            pending={shift?.type?.is_pending_leave}
                            Show_leave_name={true}
                            // hours={8}
                        />
                    </Flex>
                )}
                {!shift?.manager_approval_required &&
                    shift?.id !== -1 &&
                    !shift?.type?.leave_name && (
                        <BasicSlot fill hAlign="center" column>
                            <Flex gap="gap.small" vAlign="center">
                                <NewSlotText
                                    content={_formated_time(shift?.start_time)}
                                />
                                <ArrowRightIcon />
                                <NewSlotText
                                    content={_formated_time(shift?.end_time)}
                                />
                            </Flex>
                            <DurationText
                                content={`Durée : ${shift?.duration_str}`}
                            />
                        </BasicSlot>
                    )}
            </>
        );
    });
}

const ButtonText = styled(Text)`
    color: #fff;
    text-align: center;
    font-style: normal;
    font-weight: 600;
    line-height: 19px;
`;

const OldSlotText = styled(Text)`
    color: #616161;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
`;
const NewSlotText = styled(Text)`
    color: #242424;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
`;
const OldSlot = styled(Flex)`
    border-radius: 16px;
    background: #eff6fc;
    padding: 8px 12px;
    gap: 8px;
    /* width: 182px; */
    justify-content: center;
    align-items: center;
`;

const DurationText = styled(Text)`
    color: #616161;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
`;

const NewSlot = styled(Flex)`
    border-radius: 16px;
    background: #eff6fc;
    padding: 8px 12px;
    gap: 8px;
    /* width: 182px; */
    justify-content: center;
    align-items: center;

    border: 1px dashed var(--comm-blue-tint-102-b-88-d-8, #2b88d8);
`;

export const BreakFlex = styled(Flex)`
    border-radius: 4px;
    padding: 8px 12px;
    border: ${({ BreakRespected }) =>
        BreakRespected ? "2px dashed #E0E0E0" : "2px dashed #cc4a31"};
    background-color: ${({ BreakRespected }) =>
        BreakRespected ? "#FFF" : "#fbf6d9"};
`;

export const BreakText = styled(Text)`
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
`;

const BasicSlot = styled(Flex)`
    border-radius: 16px;
    background: #eff6fc;
    padding: 8px 12px;
`;
